import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/Layout/DashboardLayout';
import EnhancedDashboard from './components/dashboard/EnhancedDashboard';
import ModernFileExplorer from './components/ModernFileExplorer';
import Login from './pages/Login';
import Users from './pages/Users';
import Machines from './pages/Machines';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Queue from './pages/Queue';
import Documents from './pages/Documents';
import Search from './pages/Search';
import AIAssistant from './pages/AIAssistant';

const App: React.FC = () => {
    return (
        <AuthProvider>
            <div className="min-h-screen bg-gray-50">
                <Router>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <DashboardLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<EnhancedDashboard />} />
                            <Route path="files" element={<ModernFileExplorer />} />
                            <Route
                                path="users"
                                element={
                                    <ProtectedRoute requiredRole="manager">
                                        <Users />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="machines" element={<Machines />} />
                            <Route path="queue" element={<Queue />} />
                            <Route path="documents" element={<Documents />} />
                            <Route path="search" element={<Search />} />
                            <Route path="ai-assistant" element={<AIAssistant />} />
                            <Route path="profile" element={<Profile />} />
                            <Route 
                                path="settings" 
                                element={
                                    <ProtectedRoute requiredRole="admin">
                                        <Settings />
                                    </ProtectedRoute>
                                } 
                            />
                        </Route>
                    </Routes>
                </Router>
            </div>
        </AuthProvider>
    );
};

export default App;
